module.exports = __webpack_public_path__ + "media/images/khqr_big-1b86e2b0d82abb6a4d07d9bb2d4c50d3.png";